import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import SendCustomEmailModalUI from './SendCustomEmailModalUI'

class SendCustomEmailModalSF extends Component {
    constructor(props) {
        super(props);
        this.state = {
            successMsg: null,
            errorList: null,

            // form events
            submitted: false,
            // form fields
            email: 'hello text',
            emailError: null,
            message: '',
            messageError: null,
        };
    }

    render() {
        return (
            <SendCustomEmailModalUI
                context={this.props.context}
                errorList={this.state.errorList}
                successMsg={this.state.successMsg}
                setErrorList={this.setErrorList}
                // modes
                sendCustomEmailMode={this.props.sendCustomEmailMode}
                submitted={this.state.submitted}
                // event handlers
                onSubmit={this.onSubmit}
                onCancelClick={this.onSendCustomEmailCancel}
                // form fields
                email={this.state.email}
                onEmailChange={(event) => this.setState({ email: event.target.value })}
                emailError={this.state.emailError}
                setEmailError={(error) => { this.setState({ emailError: error }); }}

                message={this.state.message}
                onMessageChange={(event) => this.setState({ message: event.target.value })}
                messageError={this.state.messageError}
                setMessageError={(error) => { this.setState({ messageError: error }); }}
            />
        );
    }

    componentDidMount() {
        let context = this.props.context
        Modal.setAppElement('body')
    }

    componentDidUpdate(prevProps) {
        if (!prevProps || !this.props.lead)
            return
        if (prevProps.lead && prevProps.lead.leadId === this.props.lead.leadId)
            return
        this.setState({ email: this.props.lead.email,message:this.getDefaultMessage()})
    }

    onSendCustomEmailCancel = () => {
        this.setState({
            submitted: false, successMsg: null, errorList: null,
        })
        this.props.onSendCustomEmailCancel()
    }

    onSubmit = () => {
        if (this.state.submitted) return;

        this.setState({
            successMsg: null,
            errorList: [],
            submitted: true
        });

        RestApiUtils.post(this.props.context,
            `/api/su/leads/emails/custom`,
            this.onSubmitCallback, {
            email: this.state.email,
            message: this.state.message,
        });
    }

    onSubmitCallback = (response) => {
        let errorList = [];
        if (response && response.errorList) {
            response.errorList.forEach(error => {
                errorList.push(error.message);
            });
        }

        this.setState({
            successMsg: response.success,
            errorList: errorList,
            submitted: false
        });

        let respErrors = Array.isArray(response.errorList) ? response.errorList : [];

        if (respErrors.length === 0) {
            setTimeout(() => {
                this.setState({
                    successMsg: null
                });
                this.onSendCustomEmailCancel();
            }, 2000);
        }
    }

    setErrorList = (errorList) => {
        this.setState({ errorList: errorList });
    }

    getDefaultMessage = () => {
        return `
            Hello,
    
            Thank you for your interest in working with Clime Finance for your financing needs. As the next step in completing our due diligence, we kindly request that you complete the onboarding process on our Vert One application. Vert One® is the Digital Lending application (“App”) for Clime Finance to manage your finances, access loan information, and stay updated with the latest offerings from Clime Finance.
    
            Below are the steps for onboarding. The onboarding manual has also been attached for your reference.
    
            **Step 1: Pre-requisites**
    
            · Download the Vert-One App from Google Play store on your mobile phone (https://play.google.com/store/apps/details?id=com.vertone).
            · You should have a valid Gmail account to log in to the Vert-One App.
            · To complete the process, you will need:
    
                1. Company's PAN card
                2. Director's PAN card
                3. Director's Aadhaar Card
                4. GST Portal login details
                5. Mobile phone(s) for OTP, as registered with the GST authorities
                6. Income Tax e-portal login details
    
            · You should have details regarding Project/Contracts, if any, which you require to be financed, cash flow projections for such Project(s) or other cash flow projections for the tenor of the loan, and details of the use of Loan proceeds such as procurement of materials/equipment/vehicles/services etc. The example template (attached) can be used for providing these details.
    
            **Step 2: Know Your Customer (KYC)**
    
            · Open the Vert One App on your mobile phone to scan the Company's PAN card, Director's PAN card, and Director's Aadhaar Card. (At least one Director's KYC should be completed).
    
            **Step 3: Loan Application**
    
            · Click on the loan tile on the dashboard. Choose the loan amount, loan tenure, and purpose of the loan.
    
            **Step 4: Business Verification**
    
            · Before proceeding with Business verification, please log in with your company credentials into the GST portal and enable API request for 6 hours (see Section Loan Application - GST of the attached manual for detailed instructions).
            · On the Loan Application on the App, please provide GST Portal Username and click on generate OTP. Enter the OTP received on the GST registered mobile and submit. This process should be followed for every GST registration number of the company.
            · For ITR verification, provide the Income Tax e-portal username and password and submit.
            · Upload all pdf files (in zip file) of your Company's Bank Statements for all bank accounts for the period 1 Apr, 2022 to 29 Jul, 2024.
            · Upload your Cash Flow projections that explain the collections, all expenses (categorized), and free cash flow available for debt service in your company. We have a standard template (as attached) that you can use or provide your own model as convenient.
            · Provide details regarding the Use of Proceeds (Payment to be made from Loan proceeds) which includes Party, Item details, amount, and you can attach Proforma Invoice (if available).
    
            We look forward to supporting your financial journey. You can contact us via email at support@climefinance.com or reach out through our WhatsApp number at +1234567890 for any assistance or questions you may have.
    
            Thank You,
    
            Customer Service Team
        `;
    }
    
}

export default withRouter(SendCustomEmailModalSF);

